import React, { useState } from "react";
import Modal, {
  ModalTransition,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "@atlaskit/modal-dialog";
import { useSelector, useDispatch } from "react-redux";
import SelectAction from "../../common/components/SelectAction";
import { useParams } from "react-router-dom";
import TestRadioButtons from "./TestRadioButtons";
import TestInputPage from "./TestInputPage";
import { testFlow } from "../../redux/actions/testFlowActions";
import { addMessage } from "../../redux/actions/messageActions";
import Button from '@atlaskit/button/new';
import { useEscapeShortcut } from "../../common/utils/keybindings";
import { FLOW_RUNNER_PENDING_EVENT } from "../FlowRunner";
const TestFlowModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const flow = useSelector((state) => state.integration.flow);
  const [inputType, setInputType] = useState("NO_DATA");
  const [inputData, setInputData] = useState("");
  const [startAction, setStartAction] = useState("");
  const { sectionId = "" } = useParams();

  const triggerFlowRunnerPendingStatus = () => {
    if (typeof window === "undefined" || !flow?.id) {
      return;
    }

    const detail = {
      flowId: flow.id,
      status: "RUNNING",
      durationMs: 30000,
    };

    if (typeof CustomEvent === "function") {
      window.dispatchEvent(new CustomEvent(FLOW_RUNNER_PENDING_EVENT, { detail }));
    } else if (typeof document !== "undefined" && document.createEvent) {
      const event = document.createEvent("CustomEvent");
      event.initCustomEvent(FLOW_RUNNER_PENDING_EVENT, false, false, detail);
      window.dispatchEvent(event);
    } else {
      return;
    }
  };

  const onRunFlow = () => {
    //console.log(startAction);
    if (!startAction || startAction === "") {
      dispatch(
        addMessage(
          "Missing Start Action",
          "Please select which action to start the integration",
          "info"
        )
      );
      return;
    }
    triggerFlowRunnerPendingStatus();
    //send run request to server
    dispatch(
      testFlow({
        payload: inputData,
        flowId: flow.id,
        startActionId: startAction,
        contextType: inputType,
      })
    )
      .then(() => {
        onClose();
      })
      .catch((err) => {
        dispatch(
          addMessage(
            "Error sending test request to server",
            err?.message || "Request failed",
            "error"
          )
        );
      });
    //console.log("Run context", inputType, "action", startAction, "input", inputData);
  };
  const selectInputType = (e) => {
    setInputType(e.target.value);
  };

  const setSelectedAction = (action) => {
    setStartAction(action.value);
  };
  const onChangeInputData = (e) => {
    setInputData(e.target.value);
  };
  const onEscape=()=>{
    if(isOpen){
      onClose()

    }
  }

  useEscapeShortcut(onEscape)


  return (
    <ModalTransition>
      {isOpen && (
        <Modal shouldCloseOnOverlayClick={false} width={1000} height={600}>
          <ModalHeader>
            <ModalTitle> Run integration: {flow.name}</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div>
              Start Action:{" "}
              <SelectAction
                onSelectCallback={setSelectedAction}
                defaultSelected={sectionId}
              />
              Select how to trigger the integration:
              <br />
              <TestRadioButtons
                selectInputType={selectInputType}
                inputType={inputType}
              />
              <TestInputPage
                inputType={inputType}
                dataChangeCallback={onChangeInputData}
                value={inputData}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button appearance="subtle" onClick={onClose}>
              Close
            </Button>
            <Button appearance="primary" onClick={onRunFlow}>
              Send
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};
export default TestFlowModal;
